import { render, staticRenderFns } from "./SdsSection8OTHERForm.vue?vue&type=template&id=4341eb30"
import script from "./SdsSection8OTHERForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection8OTHERForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports